<template>
  <a-modal
    :title="$translateLang('余料入库码')"
    :visible="isShowQRcodeModal"
    @cancel="handleCancelQRCodeModal"
    :footer="null"
    width="400px"
  >
    <div class="qr-auth-container">
      <!-- 二维码 -->
      <div class="qrcode-container">
        <a-icon type="loading" v-if="isLoading" />
        <div class="qrcode" ref="QRcodeRef" v-else></div>
        <div class="qrcode-tip">
          <a-button
            type="link"
            v-if="!isLoading"
            @click="refreshQRCode"
            :loading="refreshing"
            icon="redo"
            >{{ $translateLang('刷新二维码') }}</a-button
          >
          <p>{{ $translateLang('打开微信扫码可以手动添加余料入库使用') }}</p>
        </div>
      </div>
    </div>
  </a-modal>
</template>

<script>
import {
  getSurplusQRcodeIdFn,
  postRefreshQRcodeIdFn,
} from '@/apis/qrcodeAuthentication'
import store from '@/store'
import { buryPointApi } from '@/util/commonFuncs'
import { message } from 'ant-design-vue'
import QRCode from 'qrcode'

export default {
  name: 'GQRcodeAuthentication',
  props: {
    isShowQRcode: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      refreshing: false, // 刷新状态
      status: 'waiting', // waiting, scanning, success, error, expired
      isLoading: true, // 加载状态
      isShowQRcodeModal: false, // 显示状态
    }
  },
  computed: {},
  watch: {
    isShowQRcode: {
      handler(newVal) {
        if (newVal) {
          this.isShowQRcodeModal = true
          this.initQRCode(true)
        }
      },
      immediate: true,
    },
  },
  methods: {
    // 创建验证请求
    async createAuthRequest(isInit = true) {
      // 获取最新标识
      const res = isInit
        ? await getSurplusQRcodeIdFn({
            uid: store.state.userInfo.id,
          })
        : await postRefreshQRcodeIdFn({
            uid: store.state.userInfo.id,
          })
      if (res.status) {
        this.isLoading = false
        return {
          state: res.data.id,
        }
      } else {
        this.isLoading = false
        return {
          state: '',
        }
      }
    },

    // 生成二维码
    async generateQRCode(sign) {
      try {
        // 清空容器
        if (this.$refs.QRcodeRef) {
          this.$refs.QRcodeRef.innerHTML = ''
        }
        // 生成二维码到canvas
        // m:材质
        // t:颜色
        // s:废料 - 厚度 - 云排版扫码
        // latestSign: uid生成的最新标识（用于解决用户生成二维码需要时效性问题）
        let codeUrl = `http://eggi.cn/?plankInfo=${JSON.stringify({
          uid: store.state.userInfo.id,
          m: '',
          t: '',
          s: "2-''-0",
          latestSign: sign,
        })}`
        const canvas = await QRCode.toCanvas(codeUrl, {
          width: 200,
          height: 200,
          margin: 2,
          color: {
            dark: '#000000',
            light: '#FFFFFF',
          },
        })

        // 将canvas添加到容器中
        if (this.$refs.QRcodeRef) {
          this.$refs.QRcodeRef.appendChild(canvas)
          message.success(this.$translateLang('生成二维码成功'))
          buryPointApi('supplus_storage', 'surplus_material_storage_code')
        }
      } catch (error) {
        console.error('生成二维码失败:', error)
        throw error
      }
    },

    // 初始化二维码
    async initQRCode(isInit = true) {
      try {
        this.isLoading = true
        this.status = 'waiting'

        // 创建验证请求
        const response = await this.createAuthRequest(isInit)
        // 生成二维码
        if (!response.state) {
          this.status = 'error'
          message.error(this.$translateLang('生成二维码失败'))
          return
        }
        await this.generateQRCode(response.state)
      } catch (error) {
        console.error('初始化二维码失败:', error)
        this.status = 'error'
        message.error(this.$translateLang('生成二维码失败'))
      } finally {
      }
    },
    // 刷新二维码
    async refreshQRCode() {
      this.$confirm(
        this.$translateLang('是否刷新二维码，刷新后当前二维码会失效。'),
        this.$translateLang('温馨提示'),
        {
          confirmButtonText: this.$translateLang('确定'),
          cancelButtonText: this.$translateLang('取消'),
          type: 'warning',
        }
      )
        .then(async () => {
          this.refreshing = true
          try {
            await this.initQRCode(false)
          } catch (error) {
            message.error(this.$translateLang('刷新二维码失败'))
          } finally {
            this.refreshing = false
          }
        })
        .catch(() => {
          message.info(this.$translateLang('已取消刷新'))
        })
    },
    handleCancelQRCodeModal() {
      this.$emit('close')
      this.isShowQRcodeModal = false
    },
  },
  beforeDestroy() {},
}
</script>

<style scoped lang="scss">
.qr-auth-container {
  text-align: center;
  padding: 20px 0;
  position: relative;
}

.qrcode-container {
  margin-bottom: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  .qrcode {
    width: 240px;
    height: 240px;
    display: flex;
    justify-content: center;
    margin-bottom: 16px;
    padding: 20px;
    background: #fff;
    border: 2px solid #e8e8e8;
    border-radius: 16px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    transition: all 0.3s ease;

    &:hover {
      border-color: #18a8c7;
      box-shadow: 0 6px 16px rgba(24, 144, 255, 0.15);
      transform: translateY(-2px);
    }

    canvas {
      border-radius: 12px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
      transition: all 0.3s ease;
    }
  }

  .qrcode-tip {
    color: #666;
    font-size: 14px;
    line-height: 1.6;
    text-align: center;

    p {
      margin: 6px 0;
      font-weight: 500;
      font-weight: 600;
    }
  }
}
</style>
